"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUnlockedSchedules = exports.selectUncontrolledSchedules = exports.selectControlledSchedules = void 0;
exports.createScheduleSelector = createScheduleSelector;
var main_api_1 = require("../main-api");
function createScheduleSelector(selector) {
    return function (timetable) {
        return Array.isArray(timetable) ? timetable.filter(function (t) { return selector(t); }) : [];
    };
}
exports.selectControlledSchedules = createScheduleSelector(function (r) { return r.state === main_api_1.TimetableRuleState.CONTROLLED; });
exports.selectUncontrolledSchedules = createScheduleSelector(function (r) { return r.state !== main_api_1.TimetableRuleState.CONTROLLED; });
exports.selectUnlockedSchedules = createScheduleSelector(function (r) { return r.state === main_api_1.TimetableRuleState.UNLOCKED; });
//# sourceMappingURL=schedule-selectors.js.map